import { Fragment } from 'react';
import { groupRailcardsByQuantity } from "lib/favourites";
import PassengerRow from './PassengerRow';

const Passengers = ({ adults, children, railcards = [] }) => {
  let passengerRows = [];
  let adultsCount = adults;
  let childrenCount = children;

  // Handle Family & Friends Railcard
  const familyFriendsRailcards = railcards.filter(({ code }) => code === 'FAM');
  if (familyFriendsRailcards.length) {
    // Get number of passsengers with this railcard
    const familyFriendsAdultsCount = Math.min(4, adultsCount);
    const familyFriendsChildrenCount = Math.min(4, childrenCount);

    // Update the remaining passenger count
    adultsCount -= familyFriendsAdultsCount;
    childrenCount -= familyFriendsChildrenCount;
    
    // Create rows for this railcard
    const railcardName = railcards.find(({ code }) => code === 'FAM').name;
    passengerRows = passengerRows.concat([
      <PassengerRow adults={familyFriendsAdultsCount} railcardName={railcardName} />,
      <PassengerRow children={familyFriendsChildrenCount} railcardName={railcardName} />
    ]);
  }

  // Handle Disabled Child Railcard
  const disabledChildRailcards = railcards.filter(({ code }) => code === 'DIC');
  const disabledChildRailcardsCount = disabledChildRailcards.length;
  if (disabledChildRailcardsCount) {
    // Get number of passsengers with this railcard
    const disabledChildAdultsCount = disabledChildRailcardsCount / 2;
    const disabledChildChildrenCount = disabledChildRailcardsCount / 2;

    // Update the remaining passenger count
    adultsCount -= disabledChildAdultsCount;
    childrenCount -= disabledChildChildrenCount;

    // Create rows for this railcard
    const railcardName = railcards.find(({ code }) => code === 'DIC').name;
    passengerRows = passengerRows.concat([
      <PassengerRow adults={disabledChildAdultsCount} railcardName={railcardName} />,
      <PassengerRow children={disabledChildChildrenCount} railcardName={railcardName} />
    ]);
  }

  // Handle other adult railcards
  const otherAdultRailcards = railcards.filter(({ code }) => ['FAM', 'DIC'].includes(code) === false);  
  const otherAdultRailcardsCount = otherAdultRailcards.length;
  adultsCount -= otherAdultRailcardsCount;

  if (otherAdultRailcardsCount) {
    const railcardsGrouped = groupRailcardsByQuantity(otherAdultRailcards);

    railcardsGrouped.forEach(({ quantity, name }) => {
      passengerRows.push(
        <PassengerRow adults={quantity} railcardName={name} />
      );
    });
  }

  // Handle non-railcard passengers
  if (adultsCount) {
    passengerRows.push(
      <PassengerRow adults={adultsCount} />
    );
  }
  if (childrenCount) {
    passengerRows.push(
      <PassengerRow children={childrenCount} />
    );
  }

  return (
    <div className="otrl-jp__favourite-ticket__passengers">
      {passengerRows.map((row, i) =>
        <Fragment key={i}>{row}</Fragment>
      )}
    </div>
  );
};

export default Passengers;